// @ts-nocheck
import { get } from 'lodash'
import { FormFieldLayout, FormInput } from '../../generic'

export default function DurationField({
  errors,
  keys,
  onChange,
  placeholders,
  style,
  values,
  ...props
}) {
  const firstKey = keys[0]
  const lastKey = keys[1]
  const firstKeyError = get(errors, firstKey)
  const lastKeyError = get(errors, lastKey)
  return (
    <FormFieldLayout hasErrors={!!firstKeyError || !!lastKeyError} {...props}>
      <div style={{ ...style, ...localStyles.wrapper }}>
        <FormInput
          error={firstKeyError}
          format={true}
          onChange={(e) => onChange({ key: firstKey, value: e.target.value })}
          options={{
            time: true,
            timePattern: ['h', 'm'],
          }}
          placeholder={placeholders && placeholders[0]}
          style={{ ...localStyles.inputWrapper, marginRight: 5 }}
          value={get(values, firstKey)}
        />
        <FormInput
          error={lastKeyError}
          format={true}
          onChange={(e) => onChange({ key: lastKey, value: e.target.value })}
          options={{
            time: true,
            timePattern: ['h', 'm'],
          }}
          placeholder={placeholders && placeholders[1]}
          style={{ ...localStyles.inputWrapper, marginLeft: 5 }}
          value={get(values, lastKey)}
        />
      </div>
    </FormFieldLayout>
  )
}

const localStyles = {
  inputWrapper: {
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}
